<template>
  <q-select
    v-model="prefecture"
    outlined
    :options="items"
    dense
    options-dense
    :rules="[(val) => !!val || $t('validation.required')]"
    class="input-area pref-area"
    @update:model-value="selectValue"
  />
</template>

<script setup lang="ts">
import { computed, ref } from 'vue';

interface Props {
  value?: string;
}
const props = defineProps<Props>();
const emit = defineEmits(['selectValue']);

// 入力値
const prefecture = ref(computed(() => props.value));
const items = [
  '北海道',
  '岩手県',
  '秋田県',
  '福島県',
  '栃木県',
  '埼玉県',
  '東京都',
  '新潟県',
  '石川県',
  '山梨県',
  '岐阜県',
  '愛知県',
  '滋賀県',
  '大阪府',
  '奈良県',
  '鳥取県',
  '岡山県',
  '山口県',
  '香川県',
  '高知県',
  '佐賀県',
  '熊本県',
  '宮崎県',
  '沖縄県',
  '青森県',
  '宮城県',
  '山形県',
  '茨城県',
  '群馬県',
  '千葉県',
  '神奈川',
  '富山県',
  '福井県',
  '長野県',
  '静岡県',
  '三重県',
  '京都府',
  '兵庫県',
  '和歌山',
  '島根県',
  '広島県',
  '徳島県',
  '愛媛県',
  '福岡県',
  '長崎県',
  '大分県',
  '鹿児島',
];

/**
 * プルダウン選択値を返却
 * @param event プルダウン選択値
 */
const selectValue = (event: string) => {
  emit('selectValue', event);
};
</script>

<style scoped>
.input-area.pref-area {
  width: 220px;
}
</style>
